import * as Sentry from '@sentry/react';

export const setSentryTagForUser = (user) => {
  const { _id: userId, organizationId } = user;

  Sentry.configureScope((scope) => {
    scope.setTag('userId', userId);
    scope.setTag('organizationId', organizationId);
    scope.setTag('organizationCode', user.organization?.code);
    scope.setTag('userType', user.userType);
    scope.setTag('isDemo', user.isDemo);
  });
};

export const unsetSentryTagForUser = () => {
  Sentry.configureScope((scope) => {
    scope.setTag('userId', undefined);
    scope.setTag('organizationId', undefined);
    scope.setTag('organizationCode', undefined);
    scope.setTag('userType', undefined);
    scope.setTag('isDemo', undefined);
  });
};
